import { Button, Select } from 'antd';
import ChannelTags from 'components/ChannelTags';
import CommonImage from 'components/commons/CommonImage';
import CommonTitle from 'components/commons/CommonTitle';
import EditableBox from 'components/commons/EditableBox';
import UploadImage from 'components/commons/UploadImage';
import { pick, isEqual } from 'lodash';
import React, { FC, useEffect, useRef, useState } from 'react';
import ServiceChannels from 'services/ServiceChannels';
import { Channel } from 'store/types';
import { useStore } from 'store/zustandProvider';

const cleanChannel = (inputChannel) => {
  return pick(inputChannel, ['title', 'description', 'image']);
};
interface ChannelDetailProps {
  channel: Channel;
  isMyPage?: boolean;
}
const ChannelDetail: FC<ChannelDetailProps> = ({ channel, isMyPage = false, children }) => {
  const { me } = useStore();
  const [image, setImage] = useState(undefined);

  //const [theChannel, setTheChannel] = useState<Channel>(undefined);

  const theChannel = useRef<Partial<Channel>>(channel);
  const setTheChannel = (newChannel) => {
    theChannel.current = { ...theChannel.current, ...newChannel };
  };
  useEffect(() => {
    if (channel) {
      setTheChannel(channel);
    }
  }, [channel]);

  const editTitle = (title) => {
    console.log('🚀 ~ editTitle ~ text', title);

    setTheChannel({ title });
  };

  const editDescription = (description) => {
    console.log('🚀 ~ editTitle ~ description', description);

    setTheChannel({ description });
  };

  const changeImage = (image) => {
    setImage(image);
    console.log('🚀 ~ editTitle ~ description', image);
    const editChannel = { image };
    updateChannel(editChannel);
  };

  const updateChannel = (editChannel: Channel = theChannel.current) => {
    const newChannel = cleanChannel({ ...theChannel.current, ...editChannel });
    //const oldChannel = cleanChannel(theChannel.current)
    console.log('🚀 ~ updateChannel ', newChannel);


    ServiceChannels.update({
      channelUUID: channel.uuid,
      channel: newChannel
    }).then((updated) => {
      console.log('🚀 ~ ServiceChannels.update ~ updated', updated);
      setTheChannel(updated);
    });

  };


  const addtTags = (tags: string[] = []) => {
    console.log("addtTags")
    ServiceChannels.addtTags(channel.uuid, tags)
      .then(response => {
        console.log("addtTags", response);
      })
      .catch(err => {
        console.error(err)
      })
  }



  function onChangeTags(tags: string[]) {
    console.log(`selected ${tags}`);

    addtTags(tags)

  }


  return (
    <React.Fragment>
      <CommonTitle level={2} className="mobile textCenter">
        {channel?.space?.company}
      </CommonTitle>
      {isMyPage ? (
        <UploadImage
          type="full"
          className="channelImage bgCover "
          uploadImage={image || theChannel?.current?.image || channel?.image}
          onUpload={(image) => {
            changeImage(image);
          }}
          enableCrop
        />
      ) : (
        <CommonImage image={theChannel?.current?.image || channel?.image} />
      )}
      <div className="infoWrapper">
        <div className="channelInfos flexRow">
          <div className="fullWidth">
            <EditableBox
              id="channelTitle"
              text={theChannel?.current?.title}
              disabled={!isMyPage} // use true to disable edition
              onChanged={(newText) => newText && editTitle(newText)}
              onBlur={(title) => updateChannel({ title })}
            />

            <EditableBox
              id="channelDescription"
              text={theChannel?.current?.description}
              disabled={!isMyPage} // use true to disable edition
              onChanged={(newText) => newText && editDescription(newText)}
              onBlur={(description) => updateChannel({ description })}
            />


            <ChannelTags onChangeTags={onChangeTags} tags={channel?.tags?.map(tag => tag.name)} isMyPage={isMyPage} />


            {/* <ShareComponent>
              <Button type="default" className="mobile shareButton">
                SHARE CHANNEL <SendOutlined />
              </Button> 
            </ShareComponent>*/}


          </div>

          <div>{children}</div>
        </div>
      </div>
    </React.Fragment>
  );
};
export default ChannelDetail;
